import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../Datas/siteConfig";
import "../css/footer.scss";

function Footer() {
  const top = () => window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <footer className="site-footer">
      <div className="footer-grid">
        <div>
          <h3>{siteConfig.brandName}</h3>
          <p>
            {siteConfig.companyName}
            <br />
            {siteConfig.address}
            <br />
            {siteConfig.email}
          </p>
        </div>
        <div>
          <h4>Quick links</h4>
          <Link onClick={top} to="/about">
            Our story
          </Link>
          <Link onClick={top} to="/contact">
            Contact us
          </Link>
          <Link onClick={top} to="/shipping">
            Shipping
          </Link>
          <Link onClick={top} to="/returns">
            Returns
          </Link>
        </div>
        <div>
          <h4>Policies</h4>
          <Link onClick={top} to="/privacy">
            Privacy policy
          </Link>
          <Link onClick={top} to="/terms">
            Terms of service
          </Link>
          <Link onClick={top} to="/cookies">
            Cookie policy
          </Link>
          <Link onClick={top} to="/faqs">
            FAQs
          </Link>
        </div>
        <div>
          <h4>Secure payments</h4>
          <p className="payment-methods">
            <span>VISA</span>
            <span>Mastercard</span>
            <span>AMEX</span>
            <span>Apple Pay</span>
            <span>Google Pay</span>
          </p>
        </div>
      </div>
      <div className="footer-bottom">
        <span>© 2026 {siteConfig.brandName}</span>
        <span>USD $</span>
      </div>
    </footer>
  );
}
export default Footer;
